<template>
  <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" @click="print" class="btn btn-info">
    Imprimir
    <i style="margin-left: 5px" class="fa-solid fa-print"></i>
  </button>
  <br />
  <br />
</template>

<script>
export default {
  mixins: [],

  props: ["termo"],

  components: {},

  data() {
    return {};
  },

  mounted() {
    console.log("Termo");
    console.log(this.termo);
  },

  methods: {
    print() {
      const options = {
        name: "Rocha Leilões",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css", "https://unpkg.com/kidlat-css/css/kidlat.css"],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      };

      //htmlToPaper("printMe");

      this.$htmlToPaper("printMe", options);
    },
  },
};
</script>
